/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default [ [ "anstatt", "dass" ], [ "bald", "bald" ], [ "dadurch", "dass" ], [ "dessen ungeachtet", "dass" ],
	[ "entweder", "oder" ], [ "einerseits", "andererseits" ], [ "erst", "wenn" ], [ "je", "desto" ], [ "je", "umso" ],
	[ "umso", "umso" ], [ "mal", "mal" ], [ "nicht nur", "sondern auch" ], [ "ob", "oder" ], [ "ohne", "dass" ], [ "so", "dass" ],
	[ "sowohl", "als auch" ], [ "sowohl", "wie auch" ], [ "teils", "teils" ], [ "unbeschadet dessen", "dass" ], [ "weder", "noch" ],
	[ "wenn", "auch" ], [ "wenn", "schon" ], [ "nicht weil", "sondern" ]  ];

